import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Loader from "components/Atoms/SharedComponents/Loader/Loader";

import dayjs from "dayjs";
import {
  getDriverComplaintsDetailsRequest,
  getDriverComplaintsRequest,
  updateDriverComplaintsRequest,
} from "../../services/modules/complaints/driverComplaints";
import { toast } from "react-toastify";
import DriverComplaintsTemplate from "../../templates/complaints/driverComplaints";
import ComplaintStatus from "../../components/Atoms/SharedComponents/Complaints/complaintsStatus";

function DriverComplaintsPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");

  const list = useSelector((state) => state.driverComplaints.driverComplaints);
  const count = useSelector((state) => state.driverComplaints.count);
  const details = useSelector(
    (state) => state.driverComplaints.driverComplaint,
  );
  const load = useSelector((state) => state.driverComplaints.load);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [page, setPage] = useState(1);
  const [filterObj, setFilterObj] = useState(null);

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const getDetails = async () => {
    dispatch(getDriverComplaintsDetailsRequest({ id: id }));
  };

  const getList = async (filterObj) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
        ...filterObj,
      },
    };
    dispatch(getDriverComplaintsRequest(requestData));
  };

  const handleStatus = () => {
    const requestData = {
      body: {
        route_complaint: {
          status: details?.status === "closed" ? "open" : "closed",
        },
      },
      action: () => {
        details?.status === "open"
          ? toast.success(
              t("complaints.success_resolved", {
                status: t("complaints.resolved"),
              }),
            )
          : toast.success(
              t("complaints.success_resolved", {
                status: t("complaints.unresolved"),
              }),
            );
        navigate("/driver-complaints");
      },
    };

    dispatch(updateDriverComplaintsRequest({ ...requestData, id }));
  };
  // mappedData use for create custom cell to concat multi values or navigate button
  const mappedData = list?.map((data, index) => {
    return {
      ...data,
      // button: <Button variant="outline">test</Button>,
      status: <ComplaintStatus data={data} />,
      route_id: "#" + data?.route_id,
      created_at: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
    };
  });

  const rowData = (data) => {
    setSelectedRow(data);
  };

  const breadcrumbs = [
    {
      active: true,
      path: "/",
      title: t("common.home"),
    },
    {
      active: !type ? false : true,
      path: "/driver-Complaints",
      title: t("complaints.driver_complaints_title"),
    },
    type && {
      active: false,
      title:
        type === "details"
          ? t("complaints.details_title")
          : id
            ? t("complaints.details_title")
            : t("complaints.details_title"),
    },
  ];
  const handelSubmit = (data, formik) => {};

  const filterList = [
    {
      type: "search",
      placeholder: t("complaints.search_by_driver"),
      onChange: (value) =>
        setFilterObj((s) => {
          return { ...s, keyword: value?.trim(), page_number: 1 };
        }),
      setFilterObj,
    },
    {
      type: "filter",
      placeholder: t("complaints.status"),
      onChange: (value) => {
        console.log(value);
        setFilterObj((s) => {
          return { ...s, status: value?.value, page_number: 1 };
        });
      },
      options: [
        { id: "closed", name: t("complaints.resolved") },
        { id: "open", name: t("complaints.not_resolved") },
      ],
    },
  ];

  const handleDelete = () => {};

  //list of actions to be displayed when clicked in the 3 dots
  const actionsList = ({ index, data }) => {
    return [
      {
        condition: () => {
          return true;
        },
        click: () => {
          navigate(`?type=details&id=${data?.id}`);
        },
        text: t("common.view"),
      },
    ];
  };

  //if you need more buttons in the header beside the add button
  const headerChildren = <></>;

  //if more modals needed, pass them to the modalComponents as below
  const modalComponents = [];

  //listing all tags
  useEffect(() => {
    if (filterObj) getList(filterObj);
  }, [filterObj]);

  //details of a single tag
  useEffect(() => {
    if (id) getDetails();
  }, [id]);

  return (
    <>
      <Loader open={load?.loading && load?.type === "list"} />
      <DriverComplaintsTemplate
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        data={mappedData}
        count={count}
        paginationPage={page}
        handlePageChange={handlePageChange}
        rowData={rowData}
        details={details}
        breadcrumbs={breadcrumbs}
        filterList={filterList}
        handelSubmit={handelSubmit}
        actionsList={actionsList}
        headerChildren={headerChildren}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        handleDeleteRequest={handleDelete}
        modalComponents={modalComponents}
        handleConfirmation={handleStatus}
        confirmBtnTitle={
          details?.status === "open"
            ? t("complaints.resolved")
            : t("complaints.unresolved")
        }
        color="black"
        btnColor={details?.status === "open" && "#3FABAE"}
      />
    </>
  );
}

export default DriverComplaintsPage;
